import { Checkbox } from 'semantic-ui-react';
import {
    useAreAllTableColsImportCandidates,
    useAreSomeTableColsImportCandidates,
    useMetadataStoreActions,
} from '../../../../../../stores/metadataStore';
import { TableIdType } from '../../../../../../types';

type ColumnInclusionTogglePropsType = {
    tableId: TableIdType;
};

const ColumnInclusionToggle = ({ tableId }: ColumnInclusionTogglePropsType) => {
    const { toggleTableColsImportCandidateStatus } = useMetadataStoreActions();
    const areAllColsImportCandidates = useAreAllTableColsImportCandidates(tableId);
    const areSomeColsImportCandidates = useAreSomeTableColsImportCandidates(tableId);

    return (
        <Checkbox
            checked={areAllColsImportCandidates}
            onChange={() => toggleTableColsImportCandidateStatus(tableId)}
            indeterminate={areSomeColsImportCandidates && !areAllColsImportCandidates}
        />
    );
};

export default ColumnInclusionToggle;
